// Security Actions

import {
  GET_SECURITY_AUTH_ROLE_LIST,
  GET_SECURITY_AUTH_ROLE_LIST_SUCCESS,
  GET_SECURITY_AUTH_ROLE_LIST_FAILURE,
  GET_SECURITY_AUTH_ROLE_BY_ID,
  GET_SECURITY_AUTH_ROLE_BY_ID_SUCCESS,
  GET_SECURITY_AUTH_ROLE_BY_ID_FAILURE,
  CREATE_SECURITY_AUTH_ROLE,
  CREATE_SECURITY_AUTH_ROLE_SUCCESS,
  CREATE_SECURITY_AUTH_ROLE_FAILURE,
  UPDATE_SECURITY_AUTH_ROLE,
  UPDATE_SECURITY_AUTH_ROLE_SUCCESS,
  UPDATE_SECURITY_AUTH_ROLE_FAILURE,
  DELETE_SECURITY_AUTH_ROLE,
  DELETE_SECURITY_AUTH_ROLE_SUCCESS,
  DELETE_SECURITY_AUTH_ROLE_FAILURE,
  GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST,
  GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST_SUCCESS,
  GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST_FAILURE,
  GET_SECURITY_AUTH_ROLE_TO_USER_LIST,
  GET_SECURITY_AUTH_ROLE_TO_USER_LIST_SUCCESS,
  GET_SECURITY_AUTH_ROLE_TO_USER_LIST_FAILURE,
  CREATE_SECURITY_AUTH_ROLE_TO_USER,
  CREATE_SECURITY_AUTH_ROLE_TO_USER_SUCCESS,
  CREATE_SECURITY_AUTH_ROLE_TO_USER_FAILURE,
  UPDATE_SECURITY_AUTH_ROLE_TO_USER,
  UPDATE_SECURITY_AUTH_ROLE_TO_USER_SUCCESS,
  UPDATE_SECURITY_AUTH_ROLE_TO_USER_FAILURE,
  DELETE_SECURITY_AUTH_ROLE_TO_USER,
  DELETE_SECURITY_AUTH_ROLE_TO_USER_SUCCESS,
  DELETE_SECURITY_AUTH_ROLE_TO_USER_FAILURE,
  CREATE_SECURITY_AUTH_MISSING_REQUEST,
  CREATE_SECURITY_AUTH_MISSING_REQUEST_SUCCESS,
  CREATE_SECURITY_AUTH_MISSING_REQUEST_FAILURE,
} from "./actionType";

// Get security auth role list
export const getSecurityAuthRoleList = () => ({
  type: GET_SECURITY_AUTH_ROLE_LIST,
});

export const getSecurityAuthRoleListSuccess = (data) => ({
  type: GET_SECURITY_AUTH_ROLE_LIST_SUCCESS,
  payload: data,
});

export const getSecurityAuthRoleListFailure = (data) => ({
  type: GET_SECURITY_AUTH_ROLE_LIST_FAILURE,
  payload: data,
});

// Get security auth role by id
export const getSecurityAuthRoleById = (id) => ({
  type: GET_SECURITY_AUTH_ROLE_BY_ID,
  payload: id,
});

export const getSecurityAuthRoleByIdSuccess = (data) => ({
  type: GET_SECURITY_AUTH_ROLE_BY_ID_SUCCESS,
  payload: data,
});

export const getSecurityAuthRoleByIdFailure = (data) => ({
  type: GET_SECURITY_AUTH_ROLE_BY_ID_FAILURE,
  payload: data,
});

// Create security auth role
export const createSecurityAuthRole = (data) => ({
  type: CREATE_SECURITY_AUTH_ROLE,
  payload: data,
});

export const createSecurityAuthRoleSuccess = (data) => ({
  type: CREATE_SECURITY_AUTH_ROLE_SUCCESS,
  payload: data,
});

export const createSecurityAuthRoleFailure = (data) => ({
  type: CREATE_SECURITY_AUTH_ROLE_FAILURE,
  payload: data,
});

// Update security auth role
export const updateSecurityAuthRole = (data) => ({
  type: UPDATE_SECURITY_AUTH_ROLE,
  payload: data,
});

export const updateSecurityAuthRoleSuccess = (data) => ({
  type: UPDATE_SECURITY_AUTH_ROLE_SUCCESS,
  payload: data,
});

export const updateSecurityAuthRoleFailure = (data) => ({
  type: UPDATE_SECURITY_AUTH_ROLE_FAILURE,
  payload: data,
});

// Delete security auth role
export const deleteSecurityAuthRole = (id) => ({
  type: DELETE_SECURITY_AUTH_ROLE,
  payload: id,
});

export const deleteSecurityAuthRoleSuccess = (data) => ({
  type: DELETE_SECURITY_AUTH_ROLE_SUCCESS,
  payload: data,
});

export const deleteSecurityAuthRoleFailure = (data) => ({
  type: DELETE_SECURITY_AUTH_ROLE_FAILURE,
  payload: data,
});

// Get master security auth capability list
export const getMasterSecurityAuthCapabilityList = () => ({
  type: GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST,
});

export const getMasterSecurityAuthCapabilityListSuccess = (data) => ({
  type: GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST_SUCCESS,
  payload: data,
});

export const getMasterSecurityAuthCapabilityListFailure = (data) => ({
  type: GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST_FAILURE,
  payload: data,
});

//securityauthroletouser/list
export const getSecurityAuthRoleToUserList = () => ({
  type: GET_SECURITY_AUTH_ROLE_TO_USER_LIST,
});

export const getSecurityAuthRoleToUserListSuccess = (data) => ({
  type: GET_SECURITY_AUTH_ROLE_TO_USER_LIST_SUCCESS,
  payload: data,
});

export const getSecurityAuthRoleToUserListFailure = (data) => ({
  type: GET_SECURITY_AUTH_ROLE_TO_USER_LIST_FAILURE,
  payload: data,
});

//securityauthroletouser/create
export const createSecurityAuthRoleToUser = (data) => ({
  type: CREATE_SECURITY_AUTH_ROLE_TO_USER,
  payload: data,
});

export const createSecurityAuthRoleToUserSuccess = (data) => ({
  type: CREATE_SECURITY_AUTH_ROLE_TO_USER_SUCCESS,
  payload: data,
});

export const createSecurityAuthRoleToUserFailure = (data) => ({
  type: CREATE_SECURITY_AUTH_ROLE_TO_USER_FAILURE,
  payload: data,
});

//securityauthroletouser/update - Task 24736. Takes an array of
//{ Id, StartDate?, EndDate? }; a date sent as "" clears back to open-ended.
export const updateSecurityAuthRoleToUser = (data) => ({
  type: UPDATE_SECURITY_AUTH_ROLE_TO_USER,
  payload: data,
});

export const updateSecurityAuthRoleToUserSuccess = (data) => ({
  type: UPDATE_SECURITY_AUTH_ROLE_TO_USER_SUCCESS,
  payload: data,
});

export const updateSecurityAuthRoleToUserFailure = (data) => ({
  type: UPDATE_SECURITY_AUTH_ROLE_TO_USER_FAILURE,
  payload: data,
});

//securityauthroletouser/delete
export const deleteSecurityAuthRoleToUser = (id) => ({
  type: DELETE_SECURITY_AUTH_ROLE_TO_USER,
  payload: id,
});

export const deleteSecurityAuthRoleToUserSuccess = (data) => ({
  type: DELETE_SECURITY_AUTH_ROLE_TO_USER_SUCCESS,
  payload: data,
});

export const deleteSecurityAuthRoleToUserFailure = (data) => ({
  type: DELETE_SECURITY_AUTH_ROLE_TO_USER_FAILURE,
  payload: data,
});

//securityauthmissingrequest/create
export const createSecurityAuthMissingRequest = (data) => ({
  type: CREATE_SECURITY_AUTH_MISSING_REQUEST,
  payload: data,
});

export const createSecurityAuthMissingRequestSuccess = (data) => ({
  type: CREATE_SECURITY_AUTH_MISSING_REQUEST_SUCCESS,
  payload: data,
});

export const createSecurityAuthMissingRequestFailure = (data) => ({
  type: CREATE_SECURITY_AUTH_MISSING_REQUEST_FAILURE,
  payload: data,
});
